"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isUpdatePrintableDesign = void 0;
const typeguard_1 = require("../types/typeguard");
const PrintableAction_1 = require("./PrintableAction");
const UpdatePrintableDesignRuleSet = {
  type: value => value === 'UPDATE_PRINTABLE_DESIGN',
  designId: typeguard_1.isNonEmptyString,
  designAttribute: (0, typeguard_1.optional)(typeguard_1.isNonEmptyString),
  designAttributeId: (0, typeguard_1.optional)(typeguard_1.isNonEmptyString),
  printableGroupId: typeguard_1.isNonEmptyString,
  activePage: (0, typeguard_1.optional)(value => typeof value === 'string' && ['left', 'right', 'full'].includes(value))
};
const isUpdatePrintableDesign = p => {
  return (0, PrintableAction_1.isPrintableAction)(p) && (0, typeguard_1.isType)(p, UpdatePrintableDesignRuleSet);
};
exports.isUpdatePrintableDesign = isUpdatePrintableDesign;